const prefix = 'Find the ideal';
const suffix = 'for you';

export default {
  ALLIED_HEALTH_ASSISTANT: {
    slug: 'allied-health-assistant',
    content:
      'Need Allied Health Assistance? Find an Allied Health Assistant near you.'
  },
  COUNSELLING: {
    slug: 'counselling',
    content: 'Need Counselling? Find a Counsellor near you.'
  },
  DIETITIAN: {
    slug: 'dietitian',
    content: 'Need a Dietitian? Find a Dietitian near you.'
  },
  EMPLOYMENT_SUPPORT: {
    slug: 'employment-support',
    content: 'Need Employment Support? Find Employment Support near you.'
  },
  KEYWORKER: {
    slug: 'keyworker',
    content: 'Need a Keyworker? Find a Keyworker near you.'
  },
  NURSING: {
    slug: 'nursing',
    content: 'Need Nursing services? Find a Nurse near you.'
  },
  DISABILITY: {
    slug: 'disability',
    content: `${prefix} disability support service ${suffix}`
  },
  HOME_SERVICES: {
    slug: 'home-services',
    content: `${prefix} home care service ${suffix}`
  },
  DOMESTIC_HELP: {
    slug: 'domestic-help',
    content: 'Need a Cleaner? Find a Cleaner near you.'
  },
  EXERCISE_PHYSIOLOGY: {
    slug: 'exercise-physiology',
    content: 'Need Exercise Physiology? Find an Exercise Physiologist near you.'
  },
  OCCUPATIONAL_THERAPY: {
    slug: 'occupational-therapy',
    content:
      'Need Occupational Therapy? Find an Occupational Therapist near you.'
  },
  PHYSIO: {
    slug: 'physio',
    content: 'Need Physiotherapy? Find a Physio near you.'
  },
  PLAN_MANAGEMENT: {
    slug: 'plan-management',
    content: 'Need NDIS Plan Management? Find a Plan Manager near you.'
  },
  PSYCHOLOGY: {
    slug: 'psychology',
    content: 'Need a Psychologist? Find a Psychologist near you.'
  },
  RECOVERY_COACH: {
    slug: 'recovery-coach',
    content: 'Need a Recovery Coach? Find a Recovery Coach near you.'
  },
  SPEECH_THERAPY: {
    slug: 'speech-therapy',
    content: 'Need Speech Therapy? Find a Speech Therapist near you.'
  },
  SUPPORT_COORDINATION: {
    slug: 'support-coordination',
    content:
      'Need NDIS Support Coordination? Find a Support Coordinator near you.'
  },
  SUPPORT_WORKER: {
    slug: 'support-worker',
    content: 'Need a Support Worker? Find a Support Worker near you.'
  },
  SUPPORT_COORDINATOR: {
    slug: 'support-coordinator',
    content:
      "We're here to help you find supports for your clients. Search now!"
  },
  HOME_CARE_PACKAGE: {
    slug: 'home-care-package',
    content: `${prefix} home care package ${suffix}`
  }
};
